export enum ClientTableViewColumnIdentifiers {
  ClientCode = 'ClientCode',
  ZoneCode = 'ZoneCode',
  Active = 'Active',
  Name = 'Name',
  ZoneName = 'ZoneName',
  CustomerGroup = 'CustomerGroup',
  Master = 'Master',
  ReorderStatus = 'ReorderStatus',
  Country = 'Country',
  Zone = 'Zone',
  Doors = 'Doors',
  Open = 'Open',
  PriceGroup = 'PriceGroup',
  SalesDistrict = 'SalesDistrict',
  Actions = 'Actions'
}
